import React from 'react';

// Routes
import Routes from './administration-people-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
